import { Component, OnInit,  ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
import { ComplianceMasterService } from '../../../services/compliance-master.service';
import { AlertComponent } from '../../../structure/alert/alert.component';
import { CommonFunction } from '../../../helpers/commonFunction';
import { environment } from '../../../../environments/environment';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Rx';

declare var $: any;
declare var jQuery: any;
declare var autosize: any

@Component({
  selector: 'app-compliance-item',
  templateUrl: './compliance-item.component.html',
  styleUrls: ['./compliance-item.component.css']
})

export class ComplianceItemComponent implements OnInit {

  public environmentSettings: any;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();
  complianceItemForm: FormGroup;
  complianceItems: any[];
  complianceItemId: string;
  error: any = { isError: false, errorMessage: '' };

  constructor(private ComplianceMasterService: ComplianceMasterService, private alert: AlertComponent  ) { }

  ngOnInit() {

    this.environmentSettings = environment;

    this.initialiseJqueryEvents();

  
    this.getComplianceItemList();

    this.dtOptions = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }],
      dom: 'lBfrtip',//'Bfrtip',
      // Configure the buttons
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'Compliance Confirmation Item List',
          title: 'Compliance Confirmation Item List',
          extend: 'excel',
          exportOptions: {
            columns: [0],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }

        }
      ]
    };

    this.complianceItemForm = new FormGroup({
      complianceName: new FormControl('', [Validators.required,Validators.maxLength(500), Validators.pattern("^[a-zA-Z0-9][a-zA-Z0-9\-\_\.\(\)\/ ]*[a-zA-Z]+[a-zA-Z0-9\-\_\.\(\)\/ ]*$")
      ]),

    });

  }

  getComplianceItemList() {
    this.complianceItems = [];
    this.ComplianceMasterService.getComplianceItemList()
      .subscribe(response => {
        if (response.status == 0) {
          this.complianceItems = response.data;
          this.dtTrigger.next();
        }
      })
  }

  showAddPopUp() {
    $("#myModalLabel").html('<i class="fa fa-plus"></i>Add Compliance Confirmation Item');
    $('#btnsaveGroup').show();
    $('#btnupdateGroup').hide();
    $('.modal-backdrop').remove();
    $('body').removeClass('modal-open');
    $('#groupDialog').removeClass('show').hide();
    setTimeout(() => {
      $('#groupDialog').modal('show');
    }, 100);
    this.complianceItemForm.reset();
    this.complianceItemId = "";
    this.complianceItemForm.setValue({ complianceName: "" });
    this.error = { isError: false, errorMessage: '' }
  }

  addComplianceItem() {

    if (this.complianceItemForm.status == "VALID") {
      var loginUsers = JSON.parse(localStorage.getItem("user"));
      var complianceItem = {
        complianceName: this.complianceItemForm.controls.complianceName.value,
        CreatedBy: loginUsers._id
      }

      this.ComplianceMasterService.addComplianceItem(complianceItem)
        .subscribe(response => {
          if (response.status == 0) {
            $('#groupDialog').modal('hide');
            this.alert.successWithOk1("Compliance Confirmation Item created successfully",()=>{
              $('#groupDialog').off('hidden.bs.modal');  
              $('.modal-backdrop').remove();
              $('body').removeClass('modal-open');
              
            });
            this.complianceItemForm.reset();

          } else {
            $('#groupDialog').modal('hide');
          
            this.alert.error1(JSON.stringify(response.message),()=>{
              $('#groupDialog').off('hidden.bs.modal');  
              $('.modal-backdrop').remove();
              $('body').removeClass('modal-open');
            });
          }

          if (this.dtElement.dtInstance != undefined) {
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
            });
          }
          this.getComplianceItemList();

        });
    }
    else {
      console.log('Invalid form submit.')
      return false;
    }
  }

  editComplianceItem() {

    if (this.complianceItemForm.status == "VALID") {
      var loginUsers = JSON.parse(localStorage.getItem("user"));
      var updateObject = {
        complianceName: this.complianceItemForm.controls.complianceName.value,
        ModifiedBy: loginUsers._id
      }
      this.ComplianceMasterService.updateComplianceItem(updateObject, this.complianceItemId)
        .subscribe(group => {
          if (group.status == 0) {
            $('#groupDialog').modal('toggle');
            this.alert.success("Compliamce Confirmation Item updated successfully");
            this.complianceItemForm.reset();

          } else {
            $('#groupDialog').modal('toggle');
            this.alert.error(group.message);

          }
          if (this.dtElement.dtInstance != undefined) {
            this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
              dtInstance.destroy();
            });
          }
          this.getComplianceItemList();
        });
    }
    else {
      return false;
    }
  }

  deleteConfirmation(groupId) {
    this.complianceItemId = groupId
    $('#confirmation').modal('toggle');
  }

  deleteComplianceItem() {
    this.ComplianceMasterService.deleteComplianceItem(this.complianceItemId).subscribe((data:any) => {
      if (data.status == 0) {
        $('#confirmation').modal('toggle');
        this.alert.success("Compliance Confirmation Item deleted successfully");
      }
      else {
        $('#confirmation').modal('toggle');
        this.alert.error(data.message);
      }

      if (this.dtElement.dtInstance != undefined) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
        });
      }
      this.getComplianceItemList();

    });
  }

  getComplianceById(id) {
    this.ComplianceMasterService.getComplianceItemById(id)
      .subscribe((response:any) => {
        if (response.status == 0) {
          $('#groupDialog').modal('toggle') //
          this.complianceItemId = response.data[0]._id;
          this.complianceItemForm.controls.complianceName.setValue(response.data[0].complianceName);
          $("#myModalLabel").html('<i class="fa fa-pencil"></i> Update Compliance Confirmation Item');
          $('#btnsaveGroup').hide();
          $('#btnupdateGroup').show();
          this.error = { isError: false, errorMessage: '' }
        }
      });
  }

  keyDownEnterFunction(ev) {
    if (ev.keyCode == 13) {
      if(this.complianceItemId){
        this.editComplianceItem()
      } else {
        this.addComplianceItem()
      }
    }
  }

  initialiseJqueryEvents() {
    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });
    $('#groupDialog').on('shown.bs.modal', function (e) {
      $('#groupName').focus();
    });
  }
}